import { render, staticRenderFns } from "./DeliveryContent.vue?vue&type=template&id=79fcb9bc&scoped=true"
import script from "./DeliveryContent.vue?vue&type=script&lang=js"
export * from "./DeliveryContent.vue?vue&type=script&lang=js"
import style0 from "./DeliveryContent.vue?vue&type=style&index=0&id=79fcb9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fcb9bc",
  null
  
)

export default component.exports